import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Container, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link as RouteLink } from 'react-router';
import { Eyebrow, focusOutline } from '../../components/page-primitives';
const GetInvolvedCard = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadiusCard,
    padding: '1.25rem',
    display: 'flex',
    flexDirection: 'column'
}));
const getInvolvedLinkStyles = ({ theme }) => ({
    fontSize: '0.8125rem',
    fontWeight: 600,
    color: theme.palette.secondary.light,
    textDecoration: 'none',
    '&:hover': { textDecoration: 'underline' },
    ...focusOutline(theme)
});
const GetInvolvedAnchorLink = styled('a')(getInvolvedLinkStyles);
const GetInvolvedRouteLink = styled(RouteLink)(getInvolvedLinkStyles);
const GetInvolvedLink = ({ href, children }) => {
    const external = /^https?:\/\//.test(href);
    const internalRoute = href.startsWith('/') && !href.startsWith('//');
    if (internalRoute) {
        return _jsx(GetInvolvedRouteLink, { to: href, children: children });
    }
    return (_jsx(GetInvolvedAnchorLink, { href: href, target: external ? '_blank' : undefined, rel: external ? 'noopener noreferrer' : undefined, children: children }));
};
/** Consumer-configured "Get Involved" cards (contribute, sponsor, etc.). */
export const GetInvolved = ({ heading, cards }) => {
    if (!cards || cards.length === 0) {
        return null;
    }
    return (_jsxs(Container, { maxWidth: 'xl', component: 'section', children: [_jsx(Eyebrow, { sx: { letterSpacing: '0.1em', mb: { xs: '0.875rem', sm: '1.25rem' } }, children: heading ?? 'Get Involved' }), _jsx(Box, { sx: {
                    display: 'grid',
                    gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: 'repeat(3, 1fr)' },
                    gap: '1rem'
                }, children: cards.map(card => {
                    return (_jsxs(GetInvolvedCard, { children: [_jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: '0.6875rem', mb: '0.75rem' }, children: [_jsx(Box, { sx: {
                                            width: '2.125rem',
                                            height: '2.125rem',
                                            // sx multiplies by theme.shape.borderRadius
                                            borderRadius: 1,
                                            bgcolor: 'accentSoft',
                                            color: 'secondary.light',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            flexShrink: 0,
                                            '& > svg': { fontSize: '1.125rem' }
                                        }, children: card.icon }), _jsx(Typography, { sx: { fontSize: '0.9375rem', fontWeight: 700 }, children: card.title })] }), _jsx(Typography, { sx: {
                                    fontSize: '0.8125rem',
                                    color: 'text.secondary',
                                    lineHeight: 1.55,
                                    mb: '1.125rem',
                                    flex: 1
                                }, children: card.description }), _jsx(GetInvolvedLink, { href: card.href, children: card.label })] }, card.title));
                }) })] }));
};
//# sourceMappingURL=get-involved.js.map